import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link, generatePath } from 'react-router-dom';
import EmptyStateController from 'components/EmptyStateController';
import Landmark from 'components/Landmark';
import Button from 'components/Button';
import { DEFAULT_EDIT_PLAYLIST_ROUTES } from 'screens/SinglePlaylistManager';
import ContentItemList from '../../shared/contentItemList';
import isMultiDomain from 'utils/isMultiDomain';
import { jsx as _jsx } from "react/jsx-runtime";
function PlaylistContent(_ref) {
  var playlist = _ref.playlist,
    isError = _ref.isError;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var contentItems = playlist.content;
  var isDistributed = isMultiDomain(playlist);
  var emptyContent = /*#__PURE__*/_jsx(Landmark, {
    height: 250,
    title: t('empty_playlist'),
    icon: "playlist",
    children: !isDistributed && /*#__PURE__*/_jsx(Button, {
      mt: "s",
      variant: "shaded",
      as: Link,
      to: generatePath(DEFAULT_EDIT_PLAYLIST_ROUTES.singlePlaylistContent, {
        playlistId: playlist.id
      }),
      children: t('actions_add_content')
    })
  });
  var errorContent = /*#__PURE__*/_jsx(Landmark, {
    height: 250,
    icon: "playlist",
    children: /*#__PURE__*/_jsx("strong", {
      children: t('error_404')
    })
  });
  return /*#__PURE__*/_jsx(EmptyStateController, {
    isEmpty: !contentItems || contentItems.length === 0,
    emptyContent: emptyContent,
    isError: isError,
    errorContent: errorContent,
    children: !isError && /*#__PURE__*/_jsx(ContentItemList, {
      playlist: playlist
    })
  });
}
export default PlaylistContent;